<template>
  <div class="pageInner">
    <header>
      <h4 ref="title">Parcelas Pendentes</h4>
      <p v-if="parcelas">{{ parcelas.length }} {{ `iten${ parcelas.length != 1 ? 's' : '' } pendente${ parcelas.length != 1 ? 's' : '' }` }}</p>
    </header>
    <div class="listWrap" ref="listWrap">
      <ol ref="list" v-if="parcelas">
        <li v-for="(item, i) in parcelas" :key="item" class="parcela-item">
          <label>{{ formatDate(item.vencimentoOriginal) }}</label>
          <div>
            <div>
              <span>{{ dropIndex(i) }}</span>
              <p>{{ item.turma }} - {{ item.percodigo }}</p>
            </div>
            <div>
              <div>
                <label>Valor Original</label>
                <h5>{{ formatMoney(item.valorOriginal) }}</h5>
              </div>
              <div>
                <label>Valor Atualizado</label>
                <h5>{{ formatMoney(item.valorOriginal) }}</h5>
              </div>
            </div>
          </div>
        </li>
      </ol>
    </div>
    <footer>
      <div :class="['scrollMsg', { off: ini, out: started }]" v-if="parcelas && parcelas.length > 4">
        <p>Role para baixo</p>
        <span>
          <fa :icon="['fas','chevron-down']" />
        </span>
      </div>
      <button-nav @onClick="next()">
        Continuar
      </button-nav>
    </footer>
  </div>
</template>

<script>
import { formatMoney, formatDate } from '@/services/utils.service.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import ButtonNav from '@/components/financeiro/negocieja/app/navigation/ButtonNav.vue'


gsap.registerPlugin(ScrollTrigger)
export default {
  components: {
    ButtonNav
  },
  props: {
    debitos: Object
  },
  watch: {
    debitos (value) {
      if (value) {
        this.setup()
      }
    }
  },
  data () {
    return {
      proposta: null,
      parcelas: [
        // {
        //   data: '14/04/2024',
        //   turma: 'F4MA',
        //   periodoLetivo: '2024',
        //   valorOriginal: 1110.10,
        //   valorAtualizado: 1171.32
        // },
        // {
        //   data: '14/05/2024',
        //   turma: 'F4MA',
        //   periodoLetivo: '2024',
        //   valorOriginal: 1110.10,
        //   valorAtualizado: 1171.32
        // },
        // {
        //   data: '14/06/2024',
        //   turma: 'F4MA',
        //   periodoLetivo: '2024',
        //   valorOriginal: 1110.10,
        //   valorAtualizado: 1171.32
        // },
        // {
        //   data: '14/07/2024',
        //   turma: 'F4MA',
        //   periodoLetivo: '2024',
        //   valorOriginal: 1110.10,
        //   valorAtualizado: 1171.32
        // },
        // {
        //   data: '14/07/2024',
        //   turma: 'F4MA',
        //   periodoLetivo: '2024',
        //   valorOriginal: 1110.10,
        //   valorAtualizado: 1171.32
        // },
        // {
        //   data: '14/07/2024',
        //   turma: 'F4MA',
        //   periodoLetivo: '2024',
        //   valorOriginal: 1110.10,
        //   valorAtualizado: 1171.32
        // }
      ],
      ini: true,
      started: false,
    }
  },
  mounted () {
    this.$store.dispatch('negocieja/get').then(response => {
      console.log("negocieja:", response)
      this.proposta = response
      // console.log("user:", this.currentUser)
      this.setup()
    })
  },
  methods: {
    setup (){
      // console.log("this.debitos...............:", this.debitos)
      if ( this.debitos ) {
        this.parcelas = this.debitos.mensalidadesMatriculas
      }

      // console.log("parcelas:", this.parcelas)
      this.$nextTick(() => {
        if ( this.parcelas && this.parcelas.length > 0 ) {
          setTimeout(() => {
            this.setScroll()
          }, 500)
          setTimeout(() => {
            this.ini = false
          }, 1000)
          
        }
      })
    },
    dropIndex ( i ) {
        return i < 10 ? '0' + (i + 1) : (i + 1)
    },
    formatMoney ( value ) {
      return formatMoney(value)
    },
    formatDate ( date ) {
      return formatDate(date)
    },
    setScroll () {
      const list = this.$refs.list
      const items = list.querySelectorAll('.parcela-item')
      const scroller = this.$refs.listWrap
      const itemHeight = items[0].offsetHeight
      const visibleCount = window.innerHeight < 689 ? 3 : 4
      const totalItems = items.length
      const scrollSteps = totalItems - visibleCount
      const maxOffset = scrollSteps * itemHeight

      list.style.position = 'sticky'
      list.style.top = '0'
      list.style.overflow = 'hidden'
      list.style.height = `${visibleCount * itemHeight}px`

      // Adicionar spacer para permitir scroll
      const spacer = document.createElement('div')
      spacer.style.height = `${maxOffset + scroller.offsetHeight}px`
      scroller.appendChild(spacer)

      // Definir posição inicial
      items.forEach((el, i) => {
        gsap.set(el, {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          y: i * itemHeight,
          ease: 'power1.in',
          duration: 0.3,
          opacity: i < visibleCount ? 1 : 0
        })
      })

      // Atualiza posição com snapping baseado no scroll
      scroller.addEventListener('scroll', () => {
        const scrollOffset = scroller.scrollTop
        // console.log("scrollOffset:", scrollOffset)

        if ( scrollOffset > 50 && !this.started ) this.started = true

        const rawIndex = scrollOffset / itemHeight
        let snappedIndex = Math.round(rawIndex)
            snappedIndex = Math.min(snappedIndex, totalItems - visibleCount)
            snappedIndex = Math.max(snappedIndex, 0)
        // const baseOffset = snappedIndex * itemHeight

        items.forEach((el, i) => {
          const relativeIndex = i - snappedIndex
          const isVisible = relativeIndex >= 0 && relativeIndex < visibleCount

          gsap.to(el, {
            y: relativeIndex * itemHeight,
            opacity: isVisible ? 1 : 0,
            duration: 0.3,
            ease: 'power2.out',
            overwrite: true
          })
        })
      })

      scroller.dispatchEvent(new Event('scroll'))
    },
    next () {
      if (this.hasBloqueioNegociacao) {
        this.showBloqueioModal = true
        return
      }

      if (this.debitos) {
        this.proposta.valores_corrigidos = this.debitos.valores_corrigidos
        this.$emit('onNext', this.debitos)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .pageInner {
    color: $preto-2;
    z-index: 5;
    display: flex; flex-direction: column;
    overflow: hidden;
    height: 100%;

    >header {
      max-width: 540px;
      z-index: 3;
      flex-shrink: 0;
      padding: $hmg_mid $hmg_large; margin: 0;

      >h4 {
        margin: 0; padding: 0;
      }
      p {
        margin: 0; padding: 0;
      }
      
      @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }
    }
    

    >div {
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      flex-shrink: 0;
      height: 100%;
      flex: 1;
      max-height: 100%;
      scroll-snap-type: y mandatory;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    ol {
      width: 100%;
      padding: 0 $hmg_large;
      margin: 0;
      height: calc( 120px * 4);

      @media screen and ( max-height: 689px ) {
        padding: 0 $hmg_mid;
        height: calc( 110px * 4 );
      }

      li{
        list-style: none;
        padding: 0; margin: 0 auto;
        display: flex;
        align-items: flex-start;
        gap: $mg_mini;
        height: 120px;
        width: 100%;
        max-width: calc(100% - 80px);
        left: $hmg_large;
        position: absolute;
        // transition: opacity 0.3s ease, transform 0.3s ease;
        will-change: opacity, transform;
        scroll-snap-align: start;
        opacity: 0;

        @media screen and ( max-height: 689px ) {
          max-width: calc(100% - $hmg_large);
          height: 110px;
        }

        >label {
          margin: 0; padding-top: $hmg_mid;
          width: 80px;
        }

        >div {
          display: flex; flex-direction: column;
          justify-content: space-between;
          width: 80%; height: 110px;
          border-radius: $border-radius-mid;
          background-color: $azul-escuro;
          padding: $hmg_small;

          @media screen and ( max-height: 689px ) {
            height: 100px;
          }

          >div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: $color-secondary;
            
            label {
              color: $color-success;
              margin: 0;
              font-size: $font-size-mini;
              font-weight: bold;
            }

            h5 {
              margin: 0;
            }

            > p {
              margin: 0;
            }
            > span {
              display: flex; flex-direction: column;
              width: 24px; height: 24px;
              font-size: $font-size-mini;
              border-radius: 100%;
              background-color: $color-secondary;
              align-items: center; justify-content: center;
              color: $azul-escuro;
            }
            
            > div {
              text-align: left;

              &:last-child{
                text-align: right;
              }
            }
          }
        }
      }
    }

    footer {
      padding: $hmg_large;
      position: relative;

       @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }

      a {
        position: relative;
        z-index: 101;
      }
    }

    .scrollMsg {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      position: absolute; top: 0; left: 0; right: 0;
      padding-top: $mg-small;
      margin: auto;
      width: auto;
      text-align: center;
      pointer-events: none;
      transform: translateY(-25px);
      gap: $hmg_mini;
      @extend %transition_4o;
      z-index: 100;

      p {
        margin: 0;
      }

      &.off {
        opacity: 0;
        transform: translateY(-35px);
      }
      &.out {
        opacity: 0;
        transform: translateY(10px);
      }
    }
  }
</style>

